import { useMemo, useState } from "react";
import { Pause, Play, RefreshCw, Search } from "lucide-react";
import { api } from "../lib/api";
import { formatNumber } from "../lib/format";
import { useResource } from "../hooks/useResource";
import { EmptyState, ErrorState, LoadingState, PageHeader } from "../components/Ui";

export default function MetricsPage() {
  const [query, setQuery] = useState("");
  const [live, setLive] = useState(true);
  const { data, loading, error, refresh } = useResource((signal) => api.metrics(signal), [], live ? 5_000 : undefined);
  const metrics = useMemo(() => (data || []).filter((metric) => `${metric.name} ${Object.values(metric.labels).join(" ")}`.toLowerCase().includes(query.toLowerCase())), [data, query]);
  const names = new Set(data?.map((metric) => metric.name) || []).size;

  return (
    <div className="page-stack">
      <PageHeader title="运行指标" description="Prometheus 指标的当前采样值" actions={<><button className={`button ${live ? "button-live" : "button-secondary"}`} onClick={() => setLive((value) => !value)}>{live ? <Pause size={16} /> : <Play size={16} />}{live ? "暂停实时" : "恢复实时"}</button><button className="button button-secondary" onClick={() => void refresh()}><RefreshCw size={16} />刷新</button></>} />
      <div className="filter-bar metrics-filter"><div className="search-box"><Search size={16} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="筛选指标名或标签" aria-label="筛选指标" /></div><span>{formatNumber(metrics.length)} samples · {formatNumber(names)} metrics</span></div>
      <section className="panel panel-flush metrics-panel">
        {loading && !data ? <LoadingState /> : error && !data ? <ErrorState error={error} onRetry={refresh} /> : !metrics.length ? <EmptyState label="没有匹配的指标" /> : (
          <div className="table-wrap"><table><thead><tr><th>指标</th><th>标签</th><th className="numeric">值</th></tr></thead><tbody>{metrics.map((metric, index) => (
            <tr key={`${metric.name}-${JSON.stringify(metric.labels)}-${index}`}><td><code>{metric.name}</code></td><td><div className="metric-labels">{Object.keys(metric.labels).length ? Object.entries(metric.labels).map(([key, value]) => <span key={key}><b>{key}</b>={value}</span>) : <span className="muted">无标签</span>}</div></td><td className="numeric metric-value">{formatMetricValue(metric.value)}</td></tr>
          ))}</tbody></table></div>
        )}
      </section>
    </div>
  );
}

function formatMetricValue(value: number): string {
  if (!Number.isFinite(value)) return String(value);
  if (Number.isInteger(value)) return formatNumber(value);
  return value.toLocaleString("zh-CN", { maximumFractionDigits: 5 });
}
